import { supabase } from "@/lib/supabase";
import { User } from "@/types";

export const authService = {
  /**
   * Sign in a user with email and password.
   */
  signIn: async (email: string, password: string): Promise<User | null> => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      console.error("Sign-in error:", error.message);
      throw new Error(error.message);
    }
    if (data.user && data.user.email) {
      return data.user as User;
    } else {
      throw new Error("User email is missing");
    }
  },

  /**
   * Sign up a new user with email and password.
   */
  signUp: async (email: string, password: string): Promise<User | null> => {
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) {
      console.error("Sign-up error:", error.message);
      throw new Error(error.message);
    }
    if (data.user && data.user.email) {
        return data.user as User;
      } else {
        throw new Error("User email is missing");
      }
    },

  /**
   * Sign out the currently logged-in user.
   */
  signOut: async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (error) {
      console.error("Sign-out error:", error);
      throw new Error(error.message || "Failed to sign out");
    }
  },

  /**
   * Get the current authenticated user.
   */
  getCurrentUser: async (): Promise<User | null> => {
    const { data, error } = await supabase.auth.getUser();
    if (error) {
      console.error("Get user error:", error.message);
      throw new Error(error.message);
    }
    if (data.user && data.user.email) {
        return data.user as User;
      } else {
        throw new Error("User email is missing");
      }
    },    
    update: async function updateUserMetadata(firstName: string, lastName: string) {
      try {
        const { data: { user }, error } = await supabase.auth.updateUser({
          data: {
            first_name: firstName,
            last_name: lastName
          }
        });
    
        if (error) throw error;
        
        return user;
      } catch (error) {
        console.error('Error updating user metadata:', error);
        throw error;
      }
    }
    
};
